// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_notificationShow__-0bnT {
  visibility: visible;
  opacity: 1;
  font-size: 14px;
  font-weight: 500;
  position: fixed;
  top: 14px;
  right: 12px;
  z-index: 10000;
  transform: 0.6s ease-in-out;
  animation: style_toast-in-right__d-RAR 0.7s;
  background: #fefefe;
}
.style_notificationShow__-0bnT .style_notification__RSDul {
  position: relative;
  border-radius: 3px 3px 3px 3px;
  box-shadow: 0 0 10px #999;
  opacity: 0.9;
  width: 100%;
  z-index: 100;
}
.style_notificationShow__-0bnT .style_notification__RSDul .style_notificationHeader__eNcgM {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fefefe;
  padding: 10px;
  min-width: 200px;
}
.style_notificationShow__-0bnT .style_notification__RSDul .style_notificationHeader__eNcgM .style_title__3OTUy {
  display: flex;
  align-items: center;
  padding: 0rem 0.875rem;
}
.style_notificationShow__-0bnT .style_notification__RSDul .style_notificationHeader__eNcgM .style_image__ojco0 {
  margin-right: 5px;
  width: 30px;
  display: flex;
  align-items: center;
}

.style_closeIcon__VPWXk {
  padding-top: 0.313rem;
  padding-left: 0.313rem;
}

@keyframes style_toast-in-right__d-RAR {
  from {
    transform: translateX(100%);
    visibility: hidden;
  }
  to {
    transform: translateX(0);
    visibility: visible;
  }
}
@keyframes style_toast-in-left__vJFlw {
  from {
    transform: translateX(0%);
    visibility: visible;
  }
  to {
    transform: translateX(100%);
    visibility: hidden;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/toast-messages/style.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,2BAAA;EACA,2CAAA;EACA,mBAAA;AACF;AAEE;EACE,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAAN;AACM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AACR;AACM;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AACR;;AAKA;EACE,qBAAA;EACA,sBAAA;AAFF;;AAKA;EACE;IACE,2BAAA;IACA,kBAAA;EAFF;EAIA;IACE,wBAAA;IACA,mBAAA;EAFF;AACF;AAIA;EACE;IACE,yBAAA;IACA,mBAAA;EAFF;EAIA;IACE,2BAAA;IACA,kBAAA;EAFF;AACF","sourcesContent":[".notificationShow {\n  visibility: visible;\n  opacity: 1;\n  font-size: 14px;\n  font-weight: 500;\n  position: fixed;\n  top: 14px;\n  right: 12px;\n  z-index: 10000;\n  transform: 0.6s ease-in-out;\n  animation: toast-in-right 0.7s;\n  background: #fefefe;\n  // width: 30dvw;\n\n  .notification {\n    position: relative;\n    border-radius: 3px 3px 3px 3px;\n    box-shadow: 0 0 10px #999;\n    opacity: 0.9;\n    width: 100%;\n    z-index: 100;\n\n    .notificationHeader {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      background: #fefefe;\n      padding: 10px;\n      min-width: 200px;\n      .title {\n        display: flex;\n        align-items: center;\n        padding: 0rem 0.875rem;\n      }\n      .image {\n        margin-right: 5px;\n        width: 30px;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n}\n\n.closeIcon {\n  padding-top: 0.313rem;\n  padding-left: 0.313rem;\n}\n\n@keyframes toast-in-right {\n  from {\n    transform: translateX(100%);\n    visibility: hidden;\n  }\n  to {\n    transform: translateX(0);\n    visibility: visible;\n  }\n}\n@keyframes toast-in-left {\n  from {\n    transform: translateX(0%);\n    visibility: visible;\n  }\n  to {\n    transform: translateX(100%);\n    visibility: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationShow": `style_notificationShow__-0bnT`,
	"toast-in-right": `style_toast-in-right__d-RAR`,
	"notification": `style_notification__RSDul`,
	"notificationHeader": `style_notificationHeader__eNcgM`,
	"title": `style_title__3OTUy`,
	"image": `style_image__ojco0`,
	"closeIcon": `style_closeIcon__VPWXk`,
	"toast-in-left": `style_toast-in-left__vJFlw`
};
export default ___CSS_LOADER_EXPORT___;
